import { AsyncPipe } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TagModule } from 'primeng/tag';
import { BehaviorSubject, Observable } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-sales-basis-tag',
  template: `
    @if ({ row: columnData | async }; as $) {
      <p-tag [value]="$.row?.sales_basis ? ('COMMISSION_MANAGEMENT.SALES_BASIS.' + $.row?.sales_basis?.toUpperCase() | translate) : 'N/A'"
      severity="secondary" />
    }
    `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TagModule, TranslateModule, AsyncPipe]
})
export class SalesBasisTagComponent {
  columnData: Observable<any> = new BehaviorSubject<any>(null);
  additionData: Observable<any> = new BehaviorSubject<any>(null);
}


